import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/_services/login.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-max-attempt-pop-up',
  templateUrl: './max-attempt-pop-up.component.html',
  styleUrls: ['./max-attempt-pop-up.component.css']
})
export class MaxAttemptPopUpComponent implements OnInit {

  logoFile: any;

  constructor(public loginService:LoginService) { }

  ngOnInit(): void {
    this.logoFile = sessionStorage.getItem('logoFile');
  }


  public createImgPath = (serverPath: string) => {
    if(serverPath == null || serverPath == '' || serverPath == undefined) {
      return "../../../assets/images/final automated.png";
    }
    return environment.BaseApiUrl + `/Customer/image?fileName=${serverPath}`;
  }

}
